<div class="nav-header">
  <!-- Hamburger Menu Button (Mobile Only) -->
  <button class="hamburger-btn d-md-none" (click)="toggleMobileMenu()">
    <i class="bi bi-list"></i>
  </button>

  <!-- Partner Logo on the left -->
  <div class="logo" *ngIf="partnerLogo">
    <img [src]="partnerLogo" alt="Partner Logo" class="partner-logo">
  </div>

  <div class="nav-actions">
    <button class="apply-btn" (click)="logout()">
      <img src="assets/icons/Apply.svg" alt="Apply">
    </button>
  </div>
</div>